export const user = 'vendors';
export const users = 'vendor_members';

export const leadLadder = 'lead_data';
export const fieldAgents = 'fls_names';

export const targetAchievement = 'lead_achievement';
export const pointsAccured = 'points_accrual';
export const hygieneCheck = 'trade_data';
export const reports = 'download_report';
